import script from "./Inventario.vue?vue&type=script&setup=true&lang=js"
export * from "./Inventario.vue?vue&type=script&setup=true&lang=js"

import "./Inventario.vue?vue&type=style&index=0&id=353a00e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-353a00e8"]])

export default __exports__